import { find } from "lodash";

import itemTypeIds from "../../constants/itemTypeIds";

// ------------------------------------------------------------------
// Version 2 Type IDs
// ------------------------------------------------------------------
// "Person" [Basic, Daily, Historical, Legal, Number Line, Weekly]
// "Character" [Fiction, Screenplay]
// "Employee" [Project Management]
const V2_PERSON_TYPE_ID = "6C857017-8B69-43D5-BD6A-B4A9B0A4A2EF";
// "Category" [Basic, Daily, Historical, Legal, Number Line, Weekly]
const V2_CATEGORY_TYPE_ID = "CC77EACA-AC19-4C54-806C-1C879724B069";
// "Arc" [Fiction, Screenplay]
const V2_STORYARC_TYPE_ID = "CE37D960-077A-4CE4-BB64-5452417B8DB4";
// "Project" [Project Management]
const V2_PROJECT_TYPE_ID = "DCDA3414-ECF4-4B19-98F7-94944041675E";
// "Location" [Fiction, Historical, Screenplay]
const V2_LOCATION_TYPE_ID = "3975A244-F199-4179-8361-DCF782167C1D";
// "Source" [Historical]
const V2_SOURCE_TYPE_ID = "1BF14654-D815-4B9D-AE9A-F4E256A1034A";

// ------------------------------------------------------------------
// Version 2 Role IDs
// ------------------------------------------------------------------
// For Person Type
// "Person" [Basic, Daily, Historical, Number Line, Weekly]
// "Resource" [Project Management]
// "Participant" [Fiction, Screenplay]
const V2_PERSON_ROLE_ID = "CD053561-6E09-4A43-9D2C-A138F5719C9E";
// "Observer" [Fiction, Screenplay]
const V2_OBSERVER_ROLE_ID = "20CDEE90-ADF2-44DF-8CF7-9482B606A797";
// "Client" [Legal]
const V2_CLIENT_ROLE_ID = "66A031C1-E431-4B45-951C-71E55B1B8D64";
// "Witness" [Legal]
const V2_WITNESS_ROLE_ID = "FC12A109-F06A-4517-A6EC-141F49D5C513";
// ------------------------------------------------------------------
// For Arc Type
// "Arc" [Fiction, Screenplay]
const V2_ARC_ROLE_ID = "EF87D9B5-F0B8-49D1-8E06-0241822F6E64";
// ------------------------------------------------------------------
// For Category Type
// "Category" [Basic, Daily, Historical, Legal, Number Line, Weekly]
const V2_CATEGORY_ROLE_ID = "1B0DEB1A-5DB7-4C01-8B9D-80CC3C95BE66";
// ------------------------------------------------------------------
// For Project Type
// "Project" [Project Management]
const V2_PROJECT_ROLE_ID = "3240AE9C-A291-406E-A4AA-007E1655CA34";
// ------------------------------------------------------------------
// For Location Type
// "Location" [Fiction, Historical, Screenplay]
const V2_LOCATION_ROLE_ID = "AC7F1F36-1417-4010-BBC8-B2CD81AEC94B";
// ------------------------------------------------------------------
// For Source Type
// "Source" [Historical]
const V2_SOURCE_ROLE_ID = "33D3CBC1-A4C6-4522-A825-188DE2D65C0C";
// ------------------------------------------------------------------

// TODO: How to handle "party" vs "witness" in Legal case?

// Mapping from version 2 Type ID to version 3 Type ID
let v2ToV3TypeIdsObj = {};
v2ToV3TypeIdsObj[V2_PERSON_TYPE_ID] = [itemTypeIds.PERSON_ITEM_TYPE_ID, "person", "character", "employee", "party"];
v2ToV3TypeIdsObj[V2_CATEGORY_TYPE_ID] = ["category"];
v2ToV3TypeIdsObj[V2_STORYARC_TYPE_ID] = ["storyArc"];
v2ToV3TypeIdsObj[V2_PROJECT_TYPE_ID] = ["project"];
v2ToV3TypeIdsObj[V2_LOCATION_TYPE_ID] = [itemTypeIds.LOCATION_ITEM_TYPE_ID, "location"];
v2ToV3TypeIdsObj[V2_SOURCE_TYPE_ID] = [];

// Mapping from version 2 Label to version 3 Type ID
let v2LabelToV3TypeIdsObj = {};
v2LabelToV3TypeIdsObj["Person"] = [itemTypeIds.PERSON_ITEM_TYPE_ID, "person", "character", "employee", "party"];
v2LabelToV3TypeIdsObj["Character"] = [itemTypeIds.PERSON_ITEM_TYPE_ID, "person", "character", "employee", "party"];
v2LabelToV3TypeIdsObj["Employee"] = [itemTypeIds.PERSON_ITEM_TYPE_ID, "person", "character", "employee", "party"];
v2LabelToV3TypeIdsObj["Category"] = ["category"];
v2LabelToV3TypeIdsObj["Arc"] = ["storyArc"];
v2LabelToV3TypeIdsObj["Project"] = ["project"];
v2LabelToV3TypeIdsObj["Place"] = [itemTypeIds.LOCATION_ITEM_TYPE_ID, "location"];
v2LabelToV3TypeIdsObj["Location"] = [itemTypeIds.LOCATION_ITEM_TYPE_ID, "location"];
v2LabelToV3TypeIdsObj["Source"] = [];

// Mapping from version 2 Role ID to version 3 Reference ID
let v2ToV3RoleIdsObj = {};
v2ToV3RoleIdsObj[V2_PERSON_ROLE_ID] = ["personRef", "participantRef", "assignedRef"];
v2ToV3RoleIdsObj[V2_OBSERVER_ROLE_ID] = ["witnessRef"];
v2ToV3RoleIdsObj[V2_CLIENT_ROLE_ID] = [];
v2ToV3RoleIdsObj[V2_WITNESS_ROLE_ID] = ["witnessRef"];
v2ToV3RoleIdsObj[V2_ARC_ROLE_ID] = ["storyArcRef"];
v2ToV3RoleIdsObj[V2_CATEGORY_ROLE_ID] = ["categoryRef"];
v2ToV3RoleIdsObj[V2_PROJECT_ROLE_ID] = ["projectRef"];
v2ToV3RoleIdsObj[V2_LOCATION_ROLE_ID] = ["locationRef"];
v2ToV3RoleIdsObj[V2_SOURCE_ROLE_ID] = [];

// Mapping from version 2 Role label to version 3 Reference ID
let v2LabelToV3RoleIdsObj = {};
v2LabelToV3RoleIdsObj["Person"] = ["personRef", "participantRef", "assignedRef"];
v2LabelToV3RoleIdsObj["Participant"] = ["personRef", "participantRef", "assignedRef"];
v2LabelToV3RoleIdsObj["Resource"] = ["personRef", "participantRef", "assignedRef"];
v2LabelToV3RoleIdsObj["Observer"] = ["witnessRef"];
v2LabelToV3RoleIdsObj["Client"] = [];
v2LabelToV3RoleIdsObj["Witness"] = ["witnessRef"];
v2LabelToV3RoleIdsObj["Arc"] = ["storyArcRef"];
v2LabelToV3RoleIdsObj["Category"] = ["categoryRef"];
v2LabelToV3RoleIdsObj["Project"] = ["projectRef"];
v2LabelToV3RoleIdsObj["Location"] = ["locationRef"];
v2LabelToV3RoleIdsObj["Place"] = ["locationRef"];
v2LabelToV3RoleIdsObj["Source"] = [];

export const findExistingTypeForVersion2Id = (typeIds, v2TypeId, v2TypeLabel) => {
  let arr = v2ToV3TypeIdsObj[v2TypeId];
  let type = arr && arr.length ? find(typeIds, t => arr.indexOf(t) >= 0) : null;
  if (!type) {
    arr = v2LabelToV3TypeIdsObj[v2TypeLabel];
    type = arr ? find(typeIds, t => arr.indexOf(t) >= 0) : null;
  }
  return type;
};

export const findExistingReferenceForVersion2Id = (referenceIds, v2RoleId, v2RoleLabel) => {
  let arr = v2ToV3RoleIdsObj[v2RoleId];
  let role = arr ? find(referenceIds, r => arr.indexOf(r) >= 0) : null;
  if (!role) {
    arr = v2LabelToV3RoleIdsObj[v2RoleLabel];
    role = arr ? find(referenceIds, r => arr.indexOf(r) >= 0) : null;
  }
  return role;
};
